import { Box } from "@mui/material";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import PrivilegeAlert, {
    UserAccessTypes,
} from "../../../../components/shared/PrivilegeAlert";
import SmsCampaignSelectType from "../../components/SmsCampaignSelectType";
import { SmsCampaignState } from "../../smsCampaignSlice/SmsCampaignSlice";

type TProps = {
    smsCampaign: SmsCampaignState;
    availableStepsForDestination: {
        title: string;
        availableDestinations: number[];
        component: JSX.Element;
    }[];
};

export default function CreateSmsCampaignView({
    smsCampaign,
    availableStepsForDestination,
}: TProps) {
    return (
        <Container maxWidth="sm">
            <PrivilegeAlert access={UserAccessTypes.ManageSmsCampaigns} />
            {availableStepsForDestination.length === 0 && (
                <SmsCampaignSelectType />
            )}
            {availableStepsForDestination.length > 0 && (
                <Stack
                    spacing={2}
                    sx={{ p: 2 }}
                >
                    <Stepper
                        activeStep={smsCampaign.currentStep}
                        alternativeLabel
                    >
                        {availableStepsForDestination.map((s) => {
                            return (
                                <Step key={s.title}>
                                    <StepLabel>{s.title}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>

                    <Paper sx={{ p: 2 }}>
                        {
                            availableStepsForDestination[
                                smsCampaign.currentStep
                            ].component
                        }
                    </Paper>
                </Stack>
            )}

            <Box sx={{ my: 2 }}>
                {/* <Alert severity="error">
                    همراهان عزیز پرشین سازه با توجه به شرایط این روزهای کشور،
                    متاسفانه سرویس پیامکی تبلیغاتی درحال حاضر دردسترس نبوده و
                    امکان درج لینک در سرویس پیامکی خدماتی نیز میسر نیست. به محض
                    برقراری مجدد از سوی نهادهای مرتبط، این خدمات دوباره در
                    اختیار شما عزیزان قرار می‌گیرند.
                </Alert> */}
            </Box>
        </Container>
    );
}
